import script from "./ProviderSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./ProviderSearch.vue?vue&type=script&setup=true&lang=js"

import "./ProviderSearch.vue?vue&type=style&index=0&id=a1b9c47a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1b9c47a"]])

export default __exports__